import { TagValueInfo, useAuthContext, UsersApi } from '@pull/pull-groupm-csp-api';
import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {useQuery} from 'react-query'
import SettingEditModalForm from './SettingEditModal';

type Props = {
  showModal: boolean
}

const SettingEditModalFormWrapper: FC<Props> = ({ showModal}) => {
  const modalRoot = document.getElementById("modal-root") as HTMLElement


  if (showModal) {
    return ReactDOM.createPortal(<SettingEditModalForm />,modalRoot)
  }

  return null
}

export {SettingEditModalFormWrapper}
